import React, { useEffect, useState } from 'react';
import PdfViewer from '../../../components/pdf-viewer';
import PageLoader from '../../../components/loader';

interface PDFViewerProps {
    base64Data: string;
    id: string;
    text?: string;
    dynamicClass?: string;
}

const Base64ToPdf: React.FC<PDFViewerProps> = ({ id, base64Data, text, dynamicClass }) => {
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    const base64ToBlob = (base64String: string, contentType: string = ''): Blob => {
        const sliceSize = 1024;
        const byteCharacters = atob(base64String);
        const byteArrays: Uint8Array[] = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    };

    useEffect(() => {
        const blob = base64ToBlob(base64Data, 'application/pdf');
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);

        return () => {
            URL.revokeObjectURL(url);
        };
    }, [base64Data]);

    // const applyZoom = history.location.pathname === `/document/${id}`;

    return (
        <div>
            {base64Data && pdfUrl ? (
                <PdfViewer url={pdfUrl!} text={text || 'Loading document...'} dynamicClass={dynamicClass} />
            ) : (
                <PageLoader text={text || 'Loading document...'} />
            )}
        </div>
    );
};

export default Base64ToPdf;
